/** Discord-style shortcode → unicode emoji (subset). */
export const EMOJI_SHORTCODES = {
    smile: '😄',
    grin: '😁',
    joy: '😂',
    rofl: '🤣',
    wink: '😉',
    blush: '😊',
    heart_eyes: '😍',
    kissing_heart: '😘',
    thinking: '🤔',
    neutral: '😐',
    expressionless: '😑',
    unamused: '😒',
    sweat: '😅',
    sob: '😭',
    scream: '😱',
    angry: '😠',
    rage: '😡',
    triumph: '😤',
    sleepy: '😪',
    yum: '😋',
    sunglasses: '😎',
    nerd: '🤓',
    confused: '😕',
    worried: '😟',
    frown: '☹️',
    cry: '😢',
    open_mouth: '😮',
    hushed: '😯',
    zip: '🤐',
    tongue: '😛',
    heart: '❤️',
    orange_heart: '🧡',
    yellow_heart: '💛',
    green_heart: '💚',
    blue_heart: '💙',
    purple_heart: '💜',
    broken_heart: '💔',
    fire: '🔥',
    star: '⭐',
    sparkles: '✨',
    thumbsup: '👍',
    thumbs_up: '👍',
    '+1': '👍',
    thumbsdown: '👎',
    thumbs_down: '👎',
    '-1': '👎',
    clap: '👏',
    wave: '👋',
    ok_hand: '👌',
    pray: '🙏',
    muscle: '💪',
    eyes: '👀',
    cat: '🐱',
    dog: '🐶',
    pizza: '🍕',
    beer: '🍺',
    cake: '🎂',
    tada: '🎉',
    rocket: '🚀',
    check: '✅',
    x: '❌',
    warning: '⚠️',
    question: '❓',
    exclamation: '❗',
};
export const SHORTCODE_ENTRIES = Object.entries(EMOJI_SHORTCODES).map(([name, emoji]) => ({
    name,
    emoji,
    code: `:${name}:`,
}));
//# sourceMappingURL=shortcodes.js.map